/**
 * Locally designed plugins
 */
import FontColorCustom from './FontColorCustom.js';
import FontSize from './FontSize.js';
import Icons from './Icons.js';
import KeepFontsize from './KeepFontsize.js';
import LockedText from './LockedText.js';
import SpanTag from './SpanTag.js';
import TableExtended from './TableExtended.js';
import Placeholder from './Placeholder.js';

export default [
  FontColorCustom,
  FontSize,
  Icons,
  KeepFontsize,
  LockedText,
  SpanTag,
  TableExtended,
  Placeholder,
];
